import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=4974fc77&"
import script from "./TagSelect.vue?vue&type=script&lang=ts&"
export * from "./TagSelect.vue?vue&type=script&lang=ts&"
import style0 from "./TagSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4974fc77')) {
      api.createRecord('4974fc77', component.options)
    } else {
      api.reload('4974fc77', component.options)
    }
    module.hot.accept("./TagSelect.vue?vue&type=template&id=4974fc77&", function () {
      api.rerender('4974fc77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/SearchBar/view/vue/components/TagSelect.vue"
export default component.exports